import { documentHasElements } from "modules/dom";

documentHasElements(".js-numbers-block", (NumbersBlocks) => {
    NumbersBlocks.forEach((numberBlock) => {

        const scrollDetector = numberBlock.querySelector<HTMLElement>(".scroll-detector");
        const cardsHeader = numberBlock.querySelectorAll<HTMLHeadingElement>(".cards > div h3");
        const cardsParagraph = numberBlock.querySelectorAll<HTMLParagraphElement>(".cards > div p");

        const observer = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    cardsHeader.forEach((h3: HTMLHeadingElement) => {
                        h3.classList.add("scrolled");
                    });

                    setTimeout(() => {
                        cardsParagraph.forEach((p: HTMLParagraphElement) => {
                            p.classList.add("scrolled");
                        });
                    }, 600);
                }
            });
        });

        if (scrollDetector) {
            observer.observe(scrollDetector);
        }
        
    });
});